var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 384,
    viewBox: "0 0 288 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.1 104.8C285.2 102.6 284.1 100.5 282.6 98.7L198.8 7C196.9 4.9 194.6 3.4 192.1 2.1C189.2 0.599998 186 0 182.6 0H22.7C10.3 0 0 10.6 0 23.9V359.1C0 372.5 10.3 384 22.7 384H265.8C278.2 384 288 372.5 288 359.1V115C288 111.4 287.5 107.9 286.1 104.8ZM48 114.2C48 112.7 49.8 112.1 51.4 112.1H122.2C123.8 112.1 125 112.7 125 114.2V125C125 126.4 123.9 128.1 122.2 128.1H51.4C49.8 128.1 48 126.4 48 125V114.2ZM48 242.2C48 240.7 49.8 240.1 51.4 240.1H173.6C175.2 240.1 176 240.7 176 242.2V253C176 254.4 175.3 256.1 173.6 256.1H51.4C49.8 256.1 48 254.4 48 253V242.2ZM208 317C208 318.4 207.3 320.1 205.6 320.1H51.4C49.8 320.1 48 318.4 48 317V306.2C48 304.7 49.8 304.1 51.4 304.1H205.6C207.2 304.1 208 304.7 208 306.2V317ZM240 189C240 190.4 239.3 192.1 237.6 192.1H51.4C49.8 192.1 48 190.4 48 189V178.2C48 176.7 49.8 176.1 51.4 176.1H237.6C239.2 176.1 240 176.7 240 178.2V189ZM193.1 113.1C187.5 113.1 182 107.9 182 101.8V35.8L253.2 113.1H193.1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.5e97bafabc0f9d488123d21ad3b3ad2a.svg";
export { ForwardRef as ReactComponent };